import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useLocation, useSearchParams } from "react-router-dom";
import ApprovedCollabs from "./ApprovedCollabs";
import NotApprovedCollabs from "./NotApprovedCollabs";

const Collaborations = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabFromUrl = searchParams.get("tab") || "not-approved";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  useEffect(() => {
    const tab = searchParams.get("tab") || "not-approved";
    if (tab !== activeTab) setActiveTab(tab);
  }, [location.search]);

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <h1>
        <strong>Collaborations</strong>
      </h1>

      <Tabs activeKey={activeTab} onSelect={handleTabChange} className="mb-3">
        <Tab eventKey="not-approved" title="Not Approved Collabs">
          <NotApprovedCollabs />
        </Tab>
        <Tab eventKey="approved" title="Approved Collabs">
          <ApprovedCollabs />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Collaborations;
